<template>
  <div class="pb-locked-panel">
    <i class="mdi mdi-lock-outline pb-ico" aria-hidden="true"></i>
    <div class="pb-locked-panel-body">
      <p class="pb-locked-panel-head"><strong>{{ title || entry.label }}</strong><PlanChip :plan="plan" /></p>
      <p>{{ text || entry.about }}</p>
      <div class="pb-actions">
        <slot />
        <router-link v-if="buyer && plan" :to="{ path: '/subscribe', query: { plan } }" class="pb-button sm outline">See {{ planName }}</router-link>
        <span v-else-if="plan" class="pb-muted">Ask the workspace owner about {{ planName }}.</span>
      </div>
    </div>
  </div>
</template>

<script>
import PlanChip from './PlanChip.vue';
import { LOCKED_FEATURES, planLabel } from '../lib/plans';

// A section the plan doesn't include, shown in its place: what it does, the plan that includes it, and the way to
// that plan (for a teammate, who to ask: billing is the owner's).
export default {
  name: 'LockedPanel',
  components: { PlanChip },
  props: {
    feature: { type: String, required: true },
    title: { type: String, default: '' },
    text: { type: String, default: '' }
  },
  computed: {
    entry() { return LOCKED_FEATURES[this.feature] || { label: '', about: '' }; },
    plan() { return this.$store.getters['praiseboard/availableOn'](this.feature) || ''; },
    planName() { return planLabel(this.$store.getters['praiseboard/planMatrix'], this.plan); },
    buyer() { return this.$store.getters['praiseboard/isOwner'] || !this.$store.getters['praiseboard/hasWorkspace']; }
  }
};
</script>
